var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoveForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2 10.4899L13.23 8.51993L10.02 5.30993C9.34 4.63993 8.18 5.11993 8.18 6.07993V12.3099V17.9199C8.18 18.8799 9.34 19.3599 10.02 18.6799L15.2 13.4999C16.03 12.6799 16.03 11.3199 15.2 10.4899Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveForward);
export default __webpack_public_path__ + "static/media/move-forward.0e423c4d572f2b573954d2214936a7f3.svg";
export { ForwardRef as ReactComponent };